import React, { PureComponent } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { getNotification } from '../actions/notifications'
import { ButtonBackDiv, DivContentBox } from '../components/common/styled'
import NotificationComponent from '../components/notification_component'
import Spinner3Bounce from '../components/spinner_3_bounce'

class Notification extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const { props } = this
    const {
      match: { params },
    } = props
    const { id } = params
    props.getNotification(id)
  }

  render() {
    const { props } = this
    const { errorMessage, isFetching, results } = props

    if (isFetching) {
      return <Spinner3Bounce isActive={isFetching} />
    }

    if (errorMessage) {
      return <Alert variant='danger'>{errorMessage}</Alert>
    }

    if (isFetching || !results) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }
    return (
      <div className='animated fadeIn'>
        <ButtonBackDiv>
          <Button
            bsPrefix='btn btn-w-m btn-default shadow'
            onClick={() => {
              if (window.location.search === '') {
                props.goToList()
              }
            }}
          >
            <i className='fa fa-arrow-left' />
            Back
          </Button>
          &nbsp;
          <Button
            bsPrefix='btn btn-w-m btn-default shadow'
            onClick={() => {
              const message = encodeURI(
                `subject=${results.message.subject}&body=Begin forwarded message: \n${results.message.body}`
              )
              window.location.href = `mailto:?${message}`
            }}
          >
            <i className='fa fa-share' />
            Forward
          </Button>
        </ButtonBackDiv>
        <DivContentBox>
          <div>{errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}</div>
          <NotificationComponent data={results} onSelect={this.onSelectUser} />
        </DivContentBox>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  errorMessage: state.getNotification.errorMessage,
  results: state.getNotification.results,
  isFetching: state.getNotification.isFetching,
  pageHash: ownProps.location.hash,
  navigateToIdentity: (id) => ownProps.history.push(`/notification/${id}`),
  goToList: () => window.history.back(),
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getNotification,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notification))
